import {ICON_TYPES} from '../constants';

export const BankIcon = (): JSX.Element => {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M0.666626 22.0001H24.6666V24.0001H0.666626V22.0001ZM24.6666 7.90907V10.0001H21.6666V18.0001H23.6666V20.0001H1.66663V18.0001H3.66663V10.0001H0.666626V7.90907C0.666526 7.37011 0.811621 6.84107 1.08666 6.37758C1.3617 5.91408 1.75652 5.53323 2.22963 5.27507L11.2296 0.366068C11.6702 0.124927 12.1644 -0.00146484 12.6666 -0.00146484C13.1689 -0.00146484 13.6631 0.124927 14.1036 0.366068L23.1036 5.27507C23.5767 5.53323 23.9716 5.91408 24.2466 6.37758C24.5216 6.84107 24.6667 7.37011 24.6666 7.90907ZM5.66663 18.0001H8.66663V10.0001H5.66663V18.0001ZM10.6666 10.0001V18.0001H14.6666V10.0001H10.6666ZM19.6666 10.0001H16.6666V18.0001H19.6666V10.0001ZM22.6666 7.90907C22.6667 7.72942 22.6183 7.55307 22.5266 7.39857C22.4349 7.24407 22.3033 7.11712 22.1456 7.03107L13.1456 2.12207C12.9987 2.04189 12.834 1.99988 12.6666 1.99988C12.4993 1.99988 12.3346 2.04189 12.1876 2.12207L3.18763 7.03107C3.02992 7.11712 2.89832 7.24407 2.80664 7.39857C2.71496 7.55307 2.66659 7.72942 2.66663 7.90907V8.00007H22.6666V7.90907Z'
          fill='white'
        />
      </g>
    </svg>
  );
};

BankIcon.iconType = ICON_TYPES.BANK;
